import { countryCodes } from './phone.constants';

const DEPRECATED_TIMEZONE_ALIASES = {
    'Asia/Kolkata': 'Asia/Calcutta',
    'Europe/Kiev': 'Europe/Kyiv',
};

const getTimeZonesForRegion = (code) => {
    const locale = new Intl.Locale(`en-${code}`);

    return locale.getTimeZones?.() ?? locale.timeZones;
};

const isTimezoneLookupSupported = () => {
    try {
        const zones = getTimeZonesForRegion('US');

        return Array.isArray(zones) && zones.length > 0;
    } catch {
        return false;
    }
};

// There is another implementation in keap-web to resolve timezone to a country.
// The implementation in keap-web uses moment and this implementation uses Intl.Locale.
// Intl.Locale is slightly more accurate than moment but does not work well in firefox (< 4% global usage)
// moment was not added to this repo because of concerns about js bundle size.
// Language detection fallback still works in firefox and given firefox's usage and the bundle size concern
//      this implementation seemed good.
const getCountryCodeFromTimezone = (timeZone) => {
    if (!timeZone || timeZone.startsWith('Etc/')) {
        return null;
    }

    const resolved = DEPRECATED_TIMEZONE_ALIASES[timeZone] ?? timeZone;
    const matches = [];

    for (const code of countryCodes) {
        const zones = getTimeZonesForRegion(code);

        if (zones?.includes(resolved)) {
            matches.push(code);

            if (matches.length > 1) {
                return null;
            }
        }
    }

    return matches.length === 1 ? matches[0] : null;
};

const getCountryCodeFromLanguage = () => {
    const language = navigator.language || navigator.userLanguage;

    if (!language?.includes('-')) {
        return null;
    }

    const code = language.split('-')[1].toUpperCase();

    return countryCodes.has(code) ? code : null;
};

export function detectCountryCode() {
    if (isTimezoneLookupSupported()) {
        const { timeZone } = Intl.DateTimeFormat().resolvedOptions();
        const fromTimezone = getCountryCodeFromTimezone(timeZone);

        if (fromTimezone) {
            return fromTimezone;
        }
    }

    return getCountryCodeFromLanguage();
}
